/*
 * Public API Surface of lp-click-outside
 */


export * from './lib/lp-click-outside.module';
export * from './lib/lp-click-outside.directive'
